import React, { useState, useEffect, Fragment } from 'react'
import GetApi from '../../common/api/get'
import ListingItem from './listing_item'
import { getInputValue, validate } from './utils'
import { getViewData } from '../../common/helpers/use_view_data'
import sampleSize from 'lodash/sampleSize'
import "../../i18n"
import CurrencyHelper from '../../common/helpers/currency_helper'

const PromotedProperties = ({ searchParams, lang, isSP, propertyTypes }) => {
  const [roomGroups, setRoomGroups] = useState([])
  const viewData = getViewData()

  useEffect(() => {
    if (searchParams.property_id) {
      return
    }

    const countryCode = searchParams.country && getInputValue('.js-country-code')
    const userPrefecture = viewData.userPrefecture

    const params = {
      ...searchParams,
      country_code: countryCode,
      property_id: viewData.promotedPropertyIds,
      collapse: 'property_id',
      sort: 'random',
      limit: 20,
      offset: 0,
      currency_code: CurrencyHelper.metaCurrencyCode()
    }

    if (userPrefecture) {
      params.user_prefecture = userPrefecture
    }

    const searchPath = routeUrlHelper.searchPath(
      validate(params),
      { arrayFormat: 'bracket' }
    )

    new GetApi().execute(searchPath)
      .then(({ body: { room_groups: roomGroups } }) => {
        setRoomGroups(roomGroups)
        window.scrollTo(0, 0)
      })
  }, [JSON.stringify(searchParams)])

  const { checkin, checkout, adults, rooms, destination } = searchParams

  if (!roomGroups.length) { return null }

  return (<Fragment>
    {sampleSize(roomGroups, 2).map(roomGroup => (
      <ListingItem key={roomGroup.id}
        lang={lang}
        { ...roomGroup.property }
        { ...roomGroup }
        property_type={propertyTypes[roomGroup.property.property_type]}
        checkin={checkin}
        checkout={checkout}
        adults={adults}
        rooms={rooms}
        destination={destination}
        isSP={isSP}
        lang={lang}
        isPromotion={true}
      />
    ))}
  </Fragment>)
}
export default PromotedProperties
